import { getFieldsForService } from "@/lib/serviceFormConfig";

export default function ServiceExtraFields({ serviceId, value, onChange }) {
  const fields = getFieldsForService(serviceId);
  if (fields.length === 0) return null;
  const v = value || {};

  const setKey = (key, val) => onChange({ ...v, [key]: val });

  const toggleMulti = (key, item) => {
    const list = v[key] || [];
    const next = list.includes(item) ? list.filter((x) => x !== item) : [...list, item];
    setKey(key, next);
  };

  return (
    <div className="rounded-xl border border-[#E5E3DB] bg-white p-4 space-y-4" data-testid="service-extra-fields">
      <div className="text-xs uppercase tracking-widest text-[#1E3F20] font-semibold">
        Service details
      </div>
      {fields.map((f) => (
        <div key={f.key}>
          <label className="text-sm font-medium">
            {f.label}{f.required && <span className="text-[#E06D53]"> *</span>}
          </label>

          {f.type === "text" && (
            <input
              className="octa-input mt-2"
              value={v[f.key] || ""}
              placeholder={f.placeholder || ""}
              onChange={(e) => setKey(f.key, e.target.value)}
              data-testid={`extra-${f.key}`}
            />
          )}

          {f.type === "textarea" && (
            <textarea
              className="octa-input mt-2"
              value={v[f.key] || ""}
              placeholder={f.placeholder || ""}
              onChange={(e) => setKey(f.key, e.target.value)}
              data-testid={`extra-${f.key}`}
            />
          )}

          {f.type === "select" && (
            <select
              className="octa-input mt-2"
              value={v[f.key] || ""}
              onChange={(e) => setKey(f.key, e.target.value)}
              data-testid={`extra-${f.key}`}
            >
              <option value="">Choose...</option>
              {f.options.map((o) => (
                <option key={o} value={o}>{o}</option>
              ))}
            </select>
          )}

          {f.type === "multi" && (
            <div className="grid grid-cols-2 md:grid-cols-3 gap-2 mt-2">
              {f.options.map((o) => {
                const active = (v[f.key] || []).includes(o);
                return (
                  <button
                    key={o}
                    type="button"
                    onClick={() => toggleMulti(f.key, o)}
                    className={`text-xs font-medium p-2 rounded-lg border text-center transition-colors ${active ? "bg-[#1E3F20] text-white border-[#1E3F20]" : "bg-white border-[#E5E3DB] hover:border-[#1E3F20]"}`}
                    data-testid={`extra-${f.key}-${o.replace(/\s|&|\//g, "-").toLowerCase()}`}
                  >
                    {o}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export const validateExtraFields = (serviceId, value) => {
  const fields = getFieldsForService(serviceId);
  const v = value || {};
  for (const f of fields) {
    if (!f.required) continue;
    const val = v[f.key];
    if (f.type === "multi") {
      if (!val || val.length === 0) return f.label;
    } else if (!val || String(val).trim() === "") {
      return f.label;
    }
  }
  return null;
};
